import { gql } from "@apollo/client";

export const INSURANCE_SERVICE_REQUESTS_QUERY = gql`
  query insuranceServiceRequests($documentId: Int!) {
    insuranceServiceRequests(documentId: $documentId) {
      insurerId
      insurerName
      period
      requestTypeCode
      requestUID
    }
  }
`;

export const DOCUMENT_ACTIONS_VISIBILITY_QUERY = gql`
  query documentActionsVisibility($documentId: Int!) {
    documentActionsVisibility(documentId: $documentId) {
      insuranceServiceLogs
      duplication
    }
  }
`;
